export const SESSION_SIGNED_IN = 'SESSION_SIGNED_IN';
export const SESSION_SIGNED_OUT = 'SESSION_SIGNED_OUT';
export const SESSION_ERROR = 'SESSION_ERROR';
export const SESSION_ACCOUNT_LOADED = 'SESSION_ACCOUNT_LOADED';
export const SESSION_ACCOUNT_UPDATED = 'SESSION_ACCOUNT_UPDATED';
export const SESSION_ACCOUNT_PASSWORD_CHANGED = 'SESSION_ACCOUNT_PASSWORD_CHANGED';
